//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapState, mapActions } from 'vuex';
import constant from '~/const';

export default {
  props: {
    isLoading: { type: Boolean, default: false },
  },

  data() {
    return {
      filters: {
        userLockTypeList: [],
        dateFrom: '',
        dateTo: '',
        untilFrom: '',
        untilTo: '',
      },
      constant,
    };
  },

  computed: {
    ...mapState('userSecurityLockHistory', ['filterLists']),
  },

  watch: {
    filters: {
      async handler(data) {
        await this.setFilters(data);
        this.$emit('update');
      },
      deep: true,
    },
  },

  created() {
    this.setFilters({});
  },

  methods: {
    ...mapActions('userSecurityLockHistory', ['setFilters']),
  },
};
